import { combineReducers } from '@reduxjs/toolkit';

// Old
import appUsersReducer from 'redux/reducers/appUsersReducer';
import authUserReducer from 'redux/reducers/authUserReducer';
import categories from 'redux/reducers/categoriesReducer';
import Countries from 'redux/reducers/countriesReducer';
import dialogReducer from 'redux/reducers/dialogReducer';
import OTPReducer from 'redux/reducers/otpReducer';
import PaginationAndFilters from 'redux/reducers/paginAndFiltersReducer';
import RestaurantsReducer from 'redux/reducers/restaurantsReducer';
import settings from 'redux/reducers/settings';
import SuppliersReducer from 'redux/reducers/suppliersReducer';
import usersReducer from 'redux/reducers/usersReducer';

// New
import config from 'redux/config/reducer';
import sidebar from 'redux/sidebar/reducer';

export default combineReducers({
  settings,
  authUser: authUserReducer,
  dialog: dialogReducer,
  users: usersReducer,
  PaginationAndFilters,
  restaurants: RestaurantsReducer,
  suppliers: SuppliersReducer,
  appUsers: appUsersReducer,
  categories: categories,
  otp: OTPReducer,
  countries: Countries,

  // New
  sidebar: sidebar,
  config: config,
});
